import { render } from "./TableIndexesList.vue?vue&type=template&id=41072102"
import script from "./TableIndexesList.vue?vue&type=script&lang=js"
export * from "./TableIndexesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__